import {Routes} from '@angular/router';
import {redirectToLanding} from './guard-helpers';

export const infoRoutes: Routes = [
	{
		path: 'help',
		loadComponent: () => import('../pages/help/help-page.component').then((c) => c.HelpPageComponent)
	},
	{
		path: 'cookies',
		loadComponent: () => import('../pages/cookies/cookies-page.component').then((c) => c.CookiesPageComponent)
	},
	{
		path: 'mentions-legales',
		loadComponent: () => import('../pages/mentions-legals/mentions-legals-page.component').then((c) => c.MentionsLegalsPageComponent)
	},
	{
		path: 'glossary',
		canActivate: [redirectToLanding],
		loadComponent: () => import('../pages/glossary/glossary.component').then((c) => c.GlossaryComponent)
	},
	{
		path: 'blog',
		loadComponent: () => import('../pages/blog-list/blog-list.component').then((c) => c.BlogListComponent)
	},
	{
		path: 'blog/:slug',
		loadComponent: () => import('../pages/markdown-blog/markdown-blog.component').then((c) => c.MarkdownBlogComponent)
	},
	{
		path: 'bdsm-contract',
		loadComponent: () => import('../pages/bdsm-contract/bdsm-contract-page.component').then((c) => c.BdsmContractPageComponent)
	},
	{
		path: 'bdsm-practices-dictionary',
		loadComponent: () => import('../pages/bdsm-practices-dictionary/bdsm-practices-dictionary.component').then((c) => c.BdsmPracticesDictionaryComponent)
	},
	{
		path: 'bdsm-practices/:slug',
		loadComponent: () => import('../pages/markdown-practice/markdown-practice.component').then((c) => c.MarkdownPracticeComponent)
	}
];
